import db from './idb_dexie'

const custom_value = db.table('custom_values')

async function addManyCustomValues(data) {
  // debugger
  // add a todo by passing in an object using Table.add.
  return await custom_value.bulkPut([...data])
}

async function getCustomValueByCFAndMain(cf_id, main) {
  // debugger
  let a = [`${cf_id}`, main]
  let b = [`${cf_id}`, `${main}\uffff`] 
  return await custom_value.where('main').startsWithIgnoreCase(main).and(data => data.custom_field_id == cf_id).toArray(function (cv) {
    return cv
  });
}

async function getCustomValueByCustomField(custom_field_id) {
  // debugger
  // console.log('vai pegar by cf-id');
  return await custom_value.where('custom_field_id').equals(custom_field_id).toArray(function (cv) {
    // console.log(cv.map(JSON.stringify).join('\n'));
    // cv = cv.filter(f=> f.custom_field_id == cf_id)
    // alert('pegoouu by cf-id');
    return cv
  });
}

async function getCustomValueByMain(main) {
  // console.log('vai pegar by main');
  return await custom_value.where('main').startsWithIgnoreCase(main).and(data => data.custom_field_id == 16).toArray(function (cv) {
    // console.log(cv.map(JSON.stringify).join('\n'));
    // cv = cv.filter(f=> f.custom_field_id == cf_id)
    // alert('pegoouu by main');
    return cv
  });
}

async function getAllCustomValues() {
  // console.log('vai pegar todos');
  return await custom_value.toArray(function (cv) {
    // console.log(cv.map(JSON.stringify).join('\n'));
    // cv = cv.filter(f=> f.custom_field_id == cf_id)
    // alert('pegoouu todos');
    return cv
  });
}

async function getOneCustomValue(id){
  return await custom_value.where('id').equals(id).toArray(function (cv) {
    // console.log(cv.map(JSON.stringify).join('\n'));
    // cv = cv.filter(f=> f.custom_field_id == cf_id)
    // alert('pegoouu one cv');
    return cv
  });
}

async function deleteAllCustomValues(){
  return await custom_value.clear()
}

async function deleteOneCustomValue(id){
  return await custom_value.delete(id)
}

export default {
  addManyCustomValues,
  getCustomValueByCFAndMain,
  getCustomValueByCustomField,
  getCustomValueByMain,
  getOneCustomValue,
  getAllCustomValues,
  deleteAllCustomValues,
  deleteOneCustomValue,
}